import CardItem from './components/CardItem';
import ListItem from './components/ListItem';
import LastReplies from './components/LastReplies';
import craftTags from "./utils/craftTags";
import craftBadges from "./utils/craftBadges";

export default {
  'walsgit/discussion/cards/components/CardItem': CardItem,
  'walsgit/discussion/cards/components/ListItem': ListItem,
  'walsgit/discussion/cards/components/LastReplies': LastReplies,
  'walsgit/discussion/cards/utils/craftTags': craftTags,
  'walsgit/discussion/cards/utils/craftBadges': craftBadges,
};
